import type { FormatGroup, PrintCapability, PrintFormat } from "@/types/printing"

export function formatsFor(formats: PrintFormat[], capability: PrintCapability): PrintFormat[] {
  return formats.filter((format) =>
    capability === "item" ? format.supports_item_labels : format.supports_unassigned_tags,
  )
}

export function groupFormats(formats: PrintFormat[]): FormatGroup[] {
  const groups = new Map<string, PrintFormat[]>()

  for (const format of formats) {
    groups.set(format.media, [...(groups.get(format.media) ?? []), format])
  }

  return [...groups].map(([media, groupedFormats]) => ({ media, formats: groupedFormats }))
}

export function defaultItemStyle(item: { is_container: boolean }): string {
  return item.is_container ? "label" : "equipment"
}

export function nextFormatIndex(currentIndex: number, total: number, key: string): number {
  if (total <= 0) return -1

  switch (key) {
    case "ArrowRight":
    case "ArrowDown":
      return (currentIndex + 1) % total
    case "ArrowLeft":
    case "ArrowUp":
      return (currentIndex - 1 + total) % total
    case "Home":
      return 0
    case "End":
      return total - 1
    default:
      return currentIndex
  }
}
